import Vue from 'vue'
import PrettyCheckbox from 'pretty-checkbox-vue'

Vue.use(PrettyCheckbox)



// WEBPACK FOOTER //
// ./src/front/init/components/materials.js